import useGet from 'lib/hooks/useGet';
import { STATS_UPB_MATCH_PARTNERS } from 'lib/networking/endpoints';

/**
 * useUpbMatchPartners — fetches the lightweight, name-sorted list of all partners
 * used to populate the search combobox.
 *
 * Returns { data, loading, error, refetch }
 * data shape: { data: [{ entity_id, name, cnd_id, match_pct, band }] }
 */
function useUpbMatchPartners({ influencedOnly = false } = {}) {
  return useGet(STATS_UPB_MATCH_PARTNERS, { influenced_only: influencedOnly }, false);
}

export default useUpbMatchPartners;
